<template>
  <div>
    <el-button type="primary" @click="dlgVisible = true">編集</el-button>
    <el-dialog title="サイズ詳細編集"
               :visible.sync="dlgVisible"
               append-to-body>
      <el-table :data="detailValues">
        <el-table-column>
          <template slot-scope="scope">
            {{ detailList[scope.$index].name }}
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-input type="text"
                      :value="detailValues[scope.$index].value"
                      @input="detailValues[scope.$index].value=$event;$emit('change', detailValues)"></el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SizeDetailConf',
  props: {
    detailList: {
      type: Array
    },
    detailValues: {
      type: Array
    }
  },
  watch: {
    detailList: function (value) {
      console.log('details: ' + JSON.stringify(value))
    }
  },
  data: function () {
    return {
      dlgVisible: false
    }
  }
}
</script>
